import { DescriptionMap, DescriptionMapInput } from 'generated/graphql';

export const getDescriptionMapInputForIntegrationChannel = (
  existingDescriptionMap: DescriptionMap[],
  descriptionToAdd: DescriptionMapInput,
): DescriptionMapInput[] => {
  return [
    ...new Map(
      [...existingDescriptionMap, descriptionToAdd].map((description) => [
        description.sourceID,
        description,
      ]),
    ).values(),
  ];
};
